import React, { useState, useEffect} from 'react';

// material-ui
import {CssBaseline, Grid} from '@mui/material';
import TopBar from './components/TopBar';
import { Divider } from '@mui/material';

//components
import FilerFilter from './components/FilerFilter';
import FilerFinesTable from './components/FilerFinesTable';
import FilerWaiverList from './components/FilerWaiversList';
import FilerFine from './dataObjects/FilerFine';
import AlertInfo from '../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../components/elements/AlertInfoDialog';

const FineTrackerApp = (): JSX.Element => {

    //set up browser title
    const pageTitle = 'Extranet - Fine Tracker';
    document.title = pageTitle;

    //set up state for the app
    const [showWaivers,setShowWaivers] = useState(false);
    const [fineIssues, setFineIssues] = useState<FilerFine[]>(); 
    const [pendingWaivers, setPendingWaivers] = useState<FilerFine[]>();
    const [pendingWaiversCount, setPendingWaiversCount] = useState(0);
    const [pendingNoticeCounts, setPendingNoticeCounts] = useState<any>({});
    const [onlyActive, setOnlyActive] = useState(true);
    const [searchInput, setSearchInput] = useState<string>('');
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    //payload
    useEffect(() => {
        getFineIssues();
        getPendingNoticeCounts();
        if(isFirstLoad) {
            getPendingWaivers();
            setIsFirstLoad(false);
        } 
    }, [onlyActive, searchInput]);

    const openWaiversList = () => {
        setShowWaivers(true);
    }

    const closeWaiversList = () => {
        setShowWaivers(false);
        getFineIssues(); // refresh fine issues when closing waivers list
    }

    const updateFineStatus = (status: string) => {
        status === 'active' ? setOnlyActive(true) : setOnlyActive(false);
    }

    const updateSearchInput = (input: string) => {
        setSearchInput(input);
    }

    const updatePayload = () => {
        getFineIssues();
        getPendingNoticeCounts();
    }

    const getFineIssues = async () => {
        await fetch(`/FineTracker/getFineIssues?onlyActive=${onlyActive}&name=${searchInput}`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: GetFineIssues',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let fineIssues = result.result;
                    setFineIssues(fineIssues);
                }
            }
            )
    }

    const getPendingWaivers = async () => {
        await fetch(`/FineTracker/GetPendingWaivers`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: GetPendingWaivers',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let waivers = result.result;
                    setPendingWaivers(waivers);
                    setPendingWaiversCount(waivers.length);
                }
            }
            )
    }

    const getPendingNoticeCounts = async () => {
        await fetch(`/FineTracker/GetPendingNoticeCounts`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: GetPendingNoticeCounts',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let counts = result.result;
                    setPendingNoticeCounts(counts);
                }
            }
            )
    }

    /*Error Handling*/ 
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    return (
        <div>
            <Grid container sx={{ display: 'flex' }}>
                <CssBaseline />
                <TopBar showWaivers={showWaivers} pendingWaiversCount={pendingWaiversCount} openWaiversList={openWaiversList} closeWaiversList={closeWaiversList}></TopBar>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {
                    !showWaivers &&
                    <FilerFilter issuesCount={fineIssues?fineIssues.length:0} pendingNoticeCounts={pendingNoticeCounts} updateFineStatus={updateFineStatus} updateSearchInput={updateSearchInput} updatePayload={updatePayload} ></FilerFilter>
                }
                
            </Grid>
            {
                showWaivers ? <FilerWaiverList pendingWaivers={pendingWaivers}></FilerWaiverList> : <FilerFinesTable fineIssues={fineIssues} updatePayload={updatePayload} ></FilerFinesTable>
            }
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </div>
    );
};

export default FineTrackerApp;